import React from "react";
import DataTable from "@/components/Datatable/Datatable";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { useSessionsReport } from "../../hooks/useSessionsReport";
import { useDownloadSessionsReportCsv } from "../../hooks/useDownloadSessionsReportCsv";
import { sessionsReportColumns } from "../SessionsReportColumns/SessionsReportColumns";
import SessionsReportFilters from "../SessionsReportFilters/SessionsReportFilters";
import { SessionsReportItem } from "../../api/fetchSessionsReport/types";

const columns = sessionsReportColumns();

const SessionsReportPage: React.FC = () => {
  const {
    items,
    totalCount,
    loading,
    error,
    pagination,
    sorting,
    filters,
    exportParams,
    handlePaginationChange,
    handleSortingChange,
    handleFilterChange,
  } = useSessionsReport();

  const { loading: csvLoading, downloadCsv } = useDownloadSessionsReportCsv();

  return (
    <MainPageWrapper title="Sessions Report">
      <SessionsReportFilters
        filters={filters}
        isExporting={csvLoading}
        onExportCsv={() => downloadCsv(exportParams)}
        onFilterChange={handleFilterChange}
      />
      <DataTable<SessionsReportItem>
        columns={columns}
        data={items}
        error={error}
        loading={loading}
        noDataMessage="No sessions found"
        onPageChange={(newPageIndex, newPageSize) =>
          handlePaginationChange({
            pageIndex: newPageIndex,
            pageSize: newPageSize,
          })
        }
        onSortingChange={handleSortingChange}
        pageIndex={pagination.pageIndex}
        pageSize={pagination.pageSize}
        rowKeyExtractor={(_row, index) => `${pagination.pageIndex}-${index}`}
        sorting={sorting}
        totalCount={totalCount}
      />
    </MainPageWrapper>
  );
};

export default SessionsReportPage;
